import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { defectNoticeListSchema } from '../../../common/validations/defectNotice'

import { get } from 'api/apiClient'

const params = (uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${uuid}/defect-notices`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${uuid}/defect-notices`,
      defectNoticeListSchema
    ),
})

export const useAPIGetDefectNotices = (uuid: string) => useQuery(params(uuid))

export const useAPIGetDefectNoticesSuspense = (uuid: string) =>
  useSuspenseQuery(params(uuid))
